import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'

@Component({
  selector: 'app-ddc-admin-ai-confirm-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Delete Dictionary</h2>
    <mat-dialog-content>
      <p *ngIf="!isSuccess">
        Are you sure you want to delete <strong>{{ data.title }}</strong
        >?
      </p>
      <p *ngIf="isSuccess">Dictionary deleted successfully!</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <ng-container *ngIf="!isSuccess">
        <button mat-button (click)="onNo()">No</button>
        <button color="warn" mat-raised-button (click)="onYes()">Yes</button>
      </ng-container>
      <ng-container *ngIf="isSuccess">
        <button mat-button (click)="onNo()">Close</button>
      </ng-container>
    </mat-dialog-actions>
  `,
})
export class DdcAdminAiConfirmDialogComponent {
  isSuccess: boolean = false

  constructor(
    public dialogRef: MatDialogRef<DdcAdminAiConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string },
  ) {
    this.isSuccessMessage()
  }

  protected isSuccessMessage(): boolean {
    this.isSuccess = this.data.title === 'Dictionary deleted successfully!'
    return this.isSuccess
  }

  onNo(): void {
    this.dialogRef.close(false)
  }
  onYes(): void {
    this.dialogRef.close(true)
  }
}
